<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.title')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="customerSelectItems"
            v-model="item.customer"
            :items="customerSelectItems"
            :error-messages="customerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.customer')"
            item-text="name"
            item-value="@id"
            @change="changeCustomer()"
            small-chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="productSelectItems && item.customer"
            v-model="item.product"
            :items="productSelectItems"
            :error-messages="productErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.product')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row v-if="item.customer">
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="contactSelectItems"
            v-model="item.contact"
            :items="contactSelectItems"
            :error-messages="contactErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('contact.contact')"
            item-text="name"
            item-value="@id"
            small-chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-dialog v-model="dialog" persistent max-width="600px" >
         <template v-slot:activator="{ on, attrs }">
           <v-btn  color="primary" rounded  v-bind="attrs" v-on="on">
             <v-icon>mdi-plus-circle</v-icon>
           </v-btn>
         </template>
         <v-card>
           <v-card-title>
             <h1><v-icon large>mdi-account-cash</v-icon>{{$t('contact.contacts')}}</h1>
           </v-card-title>
           <v-card-text>
             <v-container>
               <ContactForm ref="createFormContact" :values="item" :errors="violationsContact" />
             </v-container>
           </v-card-text>
           <v-card-actions>
             <v-spacer></v-spacer>
             <v-btn
               text
               @click="dialog = false"
             >
               {{$t('global.close')}}
             </v-btn>
             <v-btn
               color="primary"
               text
               @click="addContact()"
             >
               {{$t('global.add')}}
             </v-btn>
           </v-card-actions>
         </v-card>
        </v-dialog>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="ticketoriginSelectItems"
            v-model="item.origin"
            :items="ticketoriginSelectItems"
            :error-messages="originErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('ticket.ticketorigin')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" >
          <v-combobox
            v-if="ticketstatusSelectItems"
            v-model="item.status"
            :items="ticketstatusSelectItems"
            :error-messages="statusErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('ticket.ticketstatus')"
            item-text="name"
            item-value="@id"
            chips
          >

          
          <template v-slot:selection="{ attrs, item}">
            <v-chip
              class="ma-1 font-weight-bold"
              label
              :color="statuscolor(item)"
            >
              <v-icon left v-if="item.init">
                mdi-new-box
              </v-icon>
              <v-icon left v-if="item.finish">
                mdi-flag-checkered
              </v-icon>
              <v-icon left v-if="! item.finish && ! item.init">
                mdi-cached
              </v-icon>
              <span >{{ item.name }}</span>
            </v-chip>
          </template>
          <template v-slot:item="{ index, item }">
            <v-chip
              class="ma-1 font-weight-bold"
              label
              :color="statuscolor(item)"
            >
              <v-icon left v-if="item.init">
                mdi-new-box
              </v-icon>
              <v-icon left v-if="item.finish">
                mdi-flag-checkered
              </v-icon>
              <v-icon left v-if="! item.finish && ! item.init">
                mdi-cached
              </v-icon>
              <span >{{ item.name }}</span>
            </v-chip>

          </template>
        </v-combobox>
        </v-col>

      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="bugtypeSelectItems"
            v-model="item.bugType"
            :items="bugtypeSelectItems"
            :error-messages="bugTypeErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('ticket.bugtype')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="userSelectItems"
            v-model="item.assigned"
            :items="userSelectItems"
            :error-messages="assignedErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('ticket.assigned')"
            item-text="login"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="tagSelectItems"
            v-model="item.tags"
            :items="filteredTagSelectItems"
            :error-messages="tagErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('ticket.tags')"
            item-text="name"
            item-value="@id"
            :search-input.sync="search"
            multiple
            persistent-hint
            chips
            @change="changeTag()"
            >
                 <template v-slot:no-data>
                   <v-list-item>
                     <v-list-item-content>
                       <v-list-item-title>
                         {{ $t('global.no_result') }} "<strong>{{ search }}</strong>". {{ $t('global.addcombo1') }} <kbd>enter</kbd> {{ $t('global.addcombo2') }}
                       </v-list-item-title>
                     </v-list-item-content>
                   </v-list-item>
                 </template>
                 <template v-slot:selection="{ attrs, item, parent, selected }">
                   <v-chip
                     v-if="item === Object(item)"
                     v-bind="attrs"
                     color="primary"
                     :input-value="selected"
                     label
                   >
                     <span class="pr-2">
                       {{ item.name }}
                     </span>
                     <v-icon
                       small
                       @click="parent.selectItem(item)"
                     >
                       mdi-close
                     </v-icon>
                   </v-chip>
                 </template>
               </v-combobox>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="prioritySelectItems"
            v-model="item.priority"
            :items="prioritySelectItems"
            :error-messages="priorityErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('priority.priority')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <strong class="" >{{ $t('ticket.content') }}:</strong>
          <quill-editor 
            v-model="item.description" 
            class="editorQuill" 
            :options="editorOptions" 
            @input="$v.item.description.$touch()" 
            :error-messages="descriptionErrors"
            >
          </quill-editor>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="item['@id']">
          <v-textarea
            v-model="item.resolution"
            :error-messages="resolutionErrors"
            :label="$t('ticket.resolution')"
            @input="$v.item.resolution.$touch()"
            @blur="$v.item.resolution.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6" v-if="item['@id']">
          <v-text-field
            v-model.number="item.timeWork"
            :error-messages="timeWorkErrors"
            :label="$t('ticket.timeWork')"
            required
            @input="$v.item.timeWork.$touch()"
            @blur="$v.item.timeWork.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.dateBug"
            :label="$t('ticket.datebug')"
            :errormessages="dateBugErrors"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">

          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('ticket.newrelease') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.newrelease"
                :error-messages="newreleaseErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import InputDate from '../InputDate';
import { date } from '../../validators/date';
import ContactForm from '../../components/contact/Form';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'

export default {
  name: 'TicketForm',
  mixins: [validationMixin],
  components: {
    Loading,
    InputDate,
    ContactForm,
    quillEditor,
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    defaultvalues: {
      type: Object,
      required: false
    },
    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    console.log(this.item);
    this.ticketoriginGetSelectItems();
    this.ticketstatusGetSelectItems();
    this.customerGetSelectItems();
    this.bugtypeGetSelectItems();
    this.tagGetSelectItems();
    this.userGetSelectItems();
    this.priorityGetSelectItems();
    this.productGetSelectItems();
    this.contactGetSelectItems();
       
  },
  data() {
    return {
        name: null,
        description: null,
        resolution: null,
        timeWork: null,
        origin : null,
        status : null,
        customer : null,
        contact : null,
        product : null,
        bugType : null,
        tags: null,
        assigned: null,
        search: null,
        priority: null,
        newrelease: null,
        dateBug: null,
        dialog: false,
        content: '<h1>Some initial content</h1>',
        editorOptions: { 
          theme: 'snow', // Thème de l'éditeur
          placeholder: 'Insérer une description',
          modules: {       
            toolbar: 
            [             
              ['bold', 'italic','underline'],
              ['blockquote','code-block'], // Options de style de texte    
              [{ 'list': 'bullet' },{ 'list': 'ordered' }]
            ]
          }
        }
 
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_ticketorigin ||
         this.isLoading_ticketstatus ||
        this.isLoading_customer ||
       this.isLoading_product ||
      this.isLoading_bugtype ||
      this.isLoading_tag ||
      this.isLoading_user ||
      this.isLoading_contact ||
      this.isLoading_priority
       );
    },
    ...mapFields('ticketorigin', {
      ticketoriginSelectItems: 'selectItems',
      isLoading_ticketorigin : 'isLoading'
    }),
    ...mapFields('ticketstatus', {
      ticketstatusSelectItems: 'selectItems',
      isLoading_ticketstatus : 'isLoading'
    }),
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
      isLoading_customer : 'isLoading'
    }),
    ...mapFields('product', {
      productSelectItems: 'selectItems',
      isLoading_product : 'isLoading'
    }),
    ...mapFields('contact', {
      contactSelectItems: 'selectItems',
      isLoading_contact : 'isLoading',
      violationsContact : 'violations'
    }),
    ...mapFields('bugtype', {
      bugtypeSelectItems: 'selectItems',
      isLoading_bugtype : 'isLoading'
    }),
    ...mapFields('tag', {
      tagSelectItems: 'selectItems',
      isLoading_tag : 'isLoading'
    }),
    ...mapFields('user', {
      userSelectItems: 'selectItems',
      isLoading_user : 'isLoading'
    }),
    ...mapFields('priority', {
      prioritySelectItems: 'selectItems',
      isLoading_priority : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    tagErrors() {
      const errors = [];

      if (!this.$v.item.tags.$dirty) return errors;

      has(this.violations, 'tags') && errors.push(this.violations.tags);


      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.item.description.$dirty) return errors;
      has(this.violations, 'description') && errors.push(this.violations.description);
      !this.$v.item.description.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    resolutionErrors() {
      const errors = [];
      if (!this.$v.item.resolution.$dirty) return errors;
      has(this.violations, 'resolution') && errors.push(this.violations.resolution);
      return errors;
    },
    timeWorkErrors() {
      const errors = [];
      if (!this.$v.item.timeWork.$dirty) return errors;
      has(this.violations, 'timeWork') && errors.push(this.violations.timeWork);
      return errors;
    },
    originErrors() {
      const errors = [];
      if (!this.$v.item.origin.$dirty) return errors;
      has(this.violations, 'origin') && errors.push(this.violations.origin);
      return errors;
    },
    statusErrors() {
      const errors = [];
      if (!this.$v.item.status.$dirty) return errors;
      has(this.violations, 'status') && errors.push(this.violations.status);
      !this.$v.item.status.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    customerErrors() {
      const errors = [];
      if (!this.$v.item.customer.$dirty) return errors;
      has(this.violations, 'customer') && errors.push(this.violations.customer);
      !this.$v.item.customer.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    productErrors() {
      const errors = [];
      if (!this.$v.item.product.$dirty) return errors;
      has(this.violations, 'product') && errors.push(this.violations.product);
      return errors;
    },
    contactErrors() {
      const errors = [];
      if (!this.$v.item.contact.$dirty) return errors;
      has(this.violations, 'contact') && errors.push(this.violations.contact);
      return errors;
    },
    bugTypeErrors() {
      const errors = [];
      if (!this.$v.item.bugType.$dirty) return errors;
      has(this.violations, 'bugType') && errors.push(this.violations.bugType);
      !this.$v.item.bugType.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    assignedErrors() {
      const errors = [];
      if (!this.$v.item.assigned.$dirty) return errors;
      has(this.violations, 'assigned') && errors.push(this.violations.assigned);
      return errors;
    },
    priorityErrors() {
      const errors = [];
      if (!this.$v.item.priority.$dirty) return errors;
      has(this.violations, 'priority') && errors.push(this.violations.priority);

      return errors;
    },
    newreleaseErrors() {
      const errors = [];
      if (!this.$v.item.newrelease.$dirty) return errors;
      has(this.violations, 'newrelease') && errors.push(this.violations.newrelease);
      return errors;
    },
    dateBugErrors() {
      const errors = [];
      if (!this.$v.item.dateBug.$dirty) return errors;
      has(this.violations, 'dateBug') && errors.push(this.violations.dateBug);
      !this.$v.item.dateBug.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    dateEndErrors() {
      const errors = [];
      if (!this.$v.item.dateEnd.$dirty) return errors;
      has(this.violations, 'dateEnd') && errors.push(this.violations.dateEnd);
      return errors;
    },
    violations() {
      return this.errors || {};
    },
    filteredTagSelectItems() {
    return this.tagSelectItems
      ? this.tagSelectItems.filter(tag => tag.archive === false)
      : [];
  }
  },
  methods: {
    ...mapActions({
      ticketoriginGetSelectItems: 'ticketorigin/fetchSelectItems',
      ticketstatusGetSelectItems: 'ticketstatus/fetchSelectItems',
      customerGetSelectItems: 'customer/fetchSelectItems',
      productGetSelectItems: 'product/fetchSelectItems',
      bugtypeGetSelectItems: 'bugtype/fetchSelectItems',
      tagGetSelectItems: 'tag/fetchSelectItems',
      userGetSelectItems: 'user/fetchSelectItems',
      priorityGetSelectItems: 'priority/fetchSelectItems',
      contactGetSelectItems: 'contact/fetchSelectItems',
      contactCreate: 'contact/create',
    }),
    changeTag() {
      this.item.tags = this.item.tags.map(v => {
        if (typeof v === 'string') {
          if (v.trim() != '' && v.trim().length >= 2) {
            console.log(v);
            v = {
              name: v.trim(),
            }
          }
        }
        return v
      })
    },
    changeCustomer() {
      if (this.item.customer) {
        this.productGetSelectItems({'query'  : [{'id': 'customer', 'value': this.item.customer['@id'] },{'id': 'customerLoan', 'value': this.item.customer['@id'] }]  });
        this.contactGetSelectItems({'query'  : [{'id': 'customer', 'value': this.item.customer['@id'] }]  });
      }
    },
    addContact() {
      const createForm = this.$refs.createFormContact;
      createForm.$v.$touch();
      if (!createForm.$v.$invalid) {
        this.contactCreate(createForm.$v.item.$model);
      }
      this.contactGetSelectItems({'query'  : [{'id': 'customer', 'value': this.item.customer['@id'] }]  });
      this.dialog = false;
    },
    statuscolor(status) {
      if (status.important) {
        return 'error';
      }
      if (status.init) {
        return 'primary';
      }
      if (status.finish) {
        return 'success';
      }
      return 'accent';
    }
  },
  watch: {
    item() {
      if (this.item.customer) {
        this.productGetSelectItems({'query'  : [{'id': 'customer', 'value': this.item.customer['@id'] },{'id': 'customerLoan', 'value': this.item.customer['@id'] }]  });
        this.contactGetSelectItems({'query'  : [{'id': 'customer', 'value': this.item.customer['@id'] }]  });
      } else {
        this.productGetSelectItems();
      }

    },
    ticketstatusSelectItems() {
      if (this.defaultvalues) {
        if (this.item.status == null && this.defaultvalues.statusdefault != null) {
          for (var i = 0; i < this.ticketstatusSelectItems.length; i++) {
            if (this.ticketstatusSelectItems[i].name == this.defaultvalues.statusdefault) {
              this.item.status = this.ticketstatusSelectItems[i];
            }
          }
        }
      }
    },
    ticketoriginSelectItems() {
      if (this.defaultvalues) {
        if (this.item.origin == null && this.defaultvalues.origindefault != null) {
          for (var i = 0; i < this.ticketoriginSelectItems.length; i++) {
            if (this.ticketoriginSelectItems[i].name == this.defaultvalues.origindefault) {
              this.item.origin = this.ticketoriginSelectItems[i];
            }
          }
        }
      }
    },
    prioritySelectItems() {
      if (this.item.priority == null ) {
        for (var i = 0; i < this.prioritySelectItems.length; i++) {
          if (this.prioritySelectItems[i].init ) {
              this.item.priority = this.prioritySelectItems[i];
          }
        }
      }
    },
  },
  validations: {
    item: {
      name: {
        required
      },
      description: {
      },
      assigned: {
      },
      resolution: {
      },
      timeWork: {
      },
      origin: {
      },
      status: {
        required
      },
      customer: {
        required
      },
      contact: {
      },
      product:{
      },
      bugType:{
        required
      },
      tags: {
      },
      priority: {
      },
      newrelease: {
      },
      dateBug: {
        date,
        required
      },
    }
  },
};
</script>
<style>
.ql-toolbar .ql-stroke {
    fill: none;
    stroke: #fff;
}

.ql-editor::before {
  color: white !important;
  opacity: 0.33;
}
</style>